import { Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { NativeSafeZoneService } from 'src/services/native-safe-zone.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'liberro-basic-layout-hamburger-control',
  standalone: false,
  templateUrl: './basic-layout-hamburger-control.component.html',
  styleUrl: './basic-layout-hamburger-control.component.less',
  animations: [
    trigger('mobileHamburgerSlide', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-out', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
})
export class BasicLayoutHamburgerControlComponent {
  @Input() public desktopOpen = false;
  @Input() public mobileOpen = false;

  @Output() public desktopVisibleChange = new EventEmitter<boolean>();
  @Output() public toggleMobile = new EventEmitter<void>();
  @Output() public mobileItemClick = new EventEmitter<void>();
  @Output() public logout = new EventEmitter<void>();

  public nativeSafeZoneService = inject(NativeSafeZoneService);

  public links = signal<{ android: string; ios: string; facebook: string; linkedin: string; }>({
    android: '',
    ios: '',
    facebook: environment.facebookLink ?? '',
    linkedin: environment.linkedinLink ?? '',
  });

  public onDesktopVisibleChange(visible: boolean): void {
    this.desktopVisibleChange.emit(visible);
  }

  public onToggleMobile(): void {
    this.toggleMobile.emit();
  }

  public onMobileItemClick(): void {
    this.mobileItemClick.emit();
  }

  public onLogoutClick(isMobile = false): void {
    if (isMobile) this.mobileItemClick.emit();
    this.logout.emit();
  }
}

